import { CdpaButtonComponent, CdpaButtonId } from "../../../common/components/cdpaButton.component";
import { FormId } from "../common/formId";
import "./link-device-account.scss";
export class LinkDeviceAccount {
    constructor() {
        this.acceptButton = new CdpaButtonComponent(CdpaButtonId.LinkDeviceAccept);
        this.denyButton = new CdpaButtonComponent(CdpaButtonId.LinkDeviceDeny);
        this.acceptButton.onClick$.subscribe(() => {
            const form = document.getElementById(FormId.LinkDeviceAccountGrant);
            form.submit();
        });
        this.denyButton.onClick$.subscribe(() => {
            const form = document.getElementById(FormId.LinkDeviceAccountCancel);
            form.submit();
        });
        LinkDeviceAccount.initOptionalCheckAccountButton();
    }
    static initOptionalCheckAccountButton() {
        if (!document.getElementById(CdpaButtonId.LinkDeviceChangeAccount)) {
            return;
        }
        const changeAccountButton = new CdpaButtonComponent(CdpaButtonId.LinkDeviceChangeAccount);
        changeAccountButton.onClick$.subscribe(() => {
            const form = document.getElementById(FormId.LinkDeviceAccountChangeAccount);
            form.submit();
        });
    }
}
